import { useRef, useState } from 'react';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  ZoomControl
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import MarkerClusterGroup from 'react-leaflet-cluster';
import styles from './styles';
import clsx from 'clsx';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { divIcon, Icon } from 'leaflet';
import ClusterPhotosGallery from './clusterPhotoGallery';
import RigsDetailedPhotoCard from '../../checkInsDrill/rigPhotosModal/rigDetailedPhotoCard';

const zoomLevel = 4;
const initalPosition = [39.5, -98.35];

function PhotoMap({ mapData, type }) {
  const mapRef = useRef(null);
  const classes = styles();
  const [isPhotos, setIsPhotos] = useState({
    open: false,
    data: {}
  });
  const [isSinglePhoto, setIsSinglePhoto] = useState({
    data: {},
    open: false
  });

  const createClusterCustomIcon = (cluster) => {
    const childMarkers = cluster.getAllChildMarkers();
    const firstMarker = childMarkers[0];
    const firstUrl = firstMarker?.options?.icon?.options?.iconUrl || '';

    const count = cluster.getChildCount();

    return divIcon({
      html: `
            <div style="position: relative; display: inline-block;">
              <img 
                src="${firstUrl}" 
                style="width:80px; height:80px; object-fit:cover; border-radius:12px; border: 3px solid white; box-shadow:0 2px 6px rgba(0,0,0,0.3);" 
              />
              <span 
                style="
                  position: absolute;
                  bottom: 10px;
                  left: 10px;
                  background: rgba(0,0,0,0.7);
                  color: white;
                  font-size: 14px;
                  padding: 2px 6px;
                  border-radius: 12px;
                  font-weight: bold;
                "
              >
                ${count}
              </span>
            </div>
          `,
      className: 'custom-cluster',
      iconSize: [80, 80],
      iconAnchor: [40, 40],
    });
  };
  return (
        <Grid container justifyContent="center">
            <Grid item xs={12}>
                <MapContainer
                    closePopupOnClick={false}
                    className={clsx(classes.pictureMap)}
                    zoom={zoomLevel}
                    center={initalPosition}
                    scrollWheelZoom={true}
                    whenCreated={(map) => {
                      mapRef.current = map;
                    }}
                    zoomControl={false}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <ZoomControl position='bottomright' />
                    <MarkerClusterGroup
                        iconCreateFunction={createClusterCustomIcon}
                        spiderfyOnMaxZoom={false}
                        zoomToBoundsOnClick={false}
                        showCoverageOnHover={false}
                        eventHandlers={{
                          clusterclick: (e) => {
                            const cluster = e.layer;
                            const childMarkers = cluster.getAllChildMarkers();

                            const photos = childMarkers.map(
                              (m) => m.options.icon.options.iconUrl
                            );

                            const matchedData = mapData.filter((item) => photos.includes(item.picture));

                            setIsPhotos({
                              data: matchedData,
                              open: true
                            });
                          },
                        }}
                    >
                        {mapData.map((row) => {
                          const icon = new Icon({
                            iconUrl: row?.picture,
                            iconSize: [80, 80],
                            iconAnchor: [40, 40],
                            popupAnchor: [0, -50],
                            className: 'photo-icon'
                          });
                          return (
                                <Marker
                                    key={row?.grid_id}
                                    position={[row?.lat, row?.long]}
                                    icon={icon}
                                    eventHandlers={{
                                      click: () => {
                                        setIsSinglePhoto({
                                          data: {
                                            avatarLetter: row?.sRig.charAt(0),
                                            title: row?.sRig,
                                            image: row?.picture,
                                            email: row?.userEmail,
                                            comment: row?.comment,
                                            lastUpdate: row?.lastUpdate
                                          },
                                          open: true
                                        });
                                      }
                                    }}
                                >
                                    <Popup>{row?.sRig}</Popup>
                                </Marker>
                          );
                        })}
                    </MarkerClusterGroup>
                </MapContainer>
            </Grid>
            {isPhotos.open
              ? (
                    <ClusterPhotosGallery
                        open={isPhotos.open}
                        data={isPhotos.data}
                        onClose={() => {
                          setIsPhotos({
                            data: [],
                            open: false
                          });
                        }}
                        type={type}
                    />
                )
              : null}
            {isSinglePhoto.open
              ? (
                    <RigsDetailedPhotoCard
                        open={isSinglePhoto?.open}
                        handleClose={() => {
                          setIsSinglePhoto({
                            open: false,
                            data: {}
                          });
                        }}
                        data={isSinglePhoto?.data}
                    />
                )
              : null}
        </Grid>
  );
}

PhotoMap.propTypes = {
  mapData: PropTypes.array,
  type: PropTypes.string
};

export default PhotoMap;
